<template>
  <Base>
    <template v-slot:toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <slot name="leftToolbar">
              <span class="h-20px border-gray-200 border-start mx-4"></span>
              <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
                <li class="breadcrumb-item text-muted">
                  <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                    <i class="fad fa-home"></i>
                    Tableau de bord
                  </router-link>

                </li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">
                  <!--                                    <router-link :to="{name: 'form-list', params : { slug : survey.branch }}" v-if="survey">-->
                  <!--                                        Formulaires-->
                  <!--                                    </router-link>-->
                </li>
                <li class="breadcrumb-item">
                  <span class="bullet bg-gray-200 w-5px h-2px"></span>
                </li>
                <li class="breadcrumb-item text-muted">
                  {{ trans('Edit_survey') }}
                </li>
              </ul>
              </ul>
            </slot>
          </div>


          <div class="d-flex align-items-center py-1">
            <button class="btn btn-primary btn-sm ms-3" @click="print">
              <i class="fad fa-print"></i>
              {{ trans('Imprimer') }}
            </button>

            <router-link target="_blank"
                         :to="{ name: 'full-printable-view', params: { itemUuid: $route.params.itemUuid, printableUuid:  $route.params.printableUuid } }"
                         class="btn btn-warning btn-sm ms-3" @click="print">
              <i class="fad fa-file-certificate"></i>
              {{ trans('Plein ecran') }}
            </router-link>
          </div>

        </div>
      </div>
    </template>
    <template #content>
      <div class="w-100">
        <iframe id="iframe" class="flex-1 w-100" style="min-height:2000px;min-width:900px">

        </iframe>
      </div>

      <b-modal :ref="'jsonViewer'" :title="trans('Données')" centered class="modal-fullscreen" id="jsonViewer"
               scrollable size="xl">
        <div v-if="json">
          <json-viewer :value="json"></json-viewer>

        </div>
      </b-modal>

    </template>
  </Base>
</template>
<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import User from "@/entity/User";
import FileUpload from "@/components/FileUpload.vue";
import {api} from "@/services/Api";
import {auth} from "@/services/Auth";
import Swal from 'sweetalert2';
import JsonViewer from 'vue-json-viewer'
import VueCryptojs from 'vue-cryptojs'

@Component({
  components: {FileUpload, Base, JsonViewer}
})
export default class CoveragePrintable extends Vue {
  [x: string]: any;

  coreEndpoint = api.core

  mounted() {
    this.getData();
    this.$addListener(window, 'message', this.xhrListener, false);
  }

  decrypt(data: any) {
    let password = "AS@CIE@ttes#GPSB"
    password = this.$CryptoJS.enc.Utf8.parse(password);
    let i = this.$CryptoJS.enc.Utf8.parse("BBBBBBBBBBBBBBBB");
    var s = this.$CryptoJS.AES.decrypt(data, password, {
      iv: i,
      mode: this.$CryptoJS.mode.CBC
    }).toString(this.$CryptoJS.enc.Utf8);
    try {
      const datum = JSON.parse(s)
      console.log(datum.data)
      if (datum.data.length > 0) {
        const att = datum.data[0].attestion
        console.log(att)
      } else {
        'numero inexistant'
      }
    } catch (e) {

    }
  }

  async getData(retry = false) {
    this.$store.commit('loading')
    var xhr = new XMLHttpRequest();
    let url = this.coreEndpoint + 'item/printable/coverage/' + this.$route.params.printableSlug + '/'+ this.$route.params.coverageUuid +  '?zone=' + this.$store.state.mainStore.currentTenant.code
    if (retry) {
      // Force core a supprimer le cache disque et a re-tenter le telechargement ASACI
      url += '&retry=1&_t=' + Date.now()
    }

    const res = await api.refreshToken()
    // var data_url = URL.createObjectURL(res.data);
    // document.querySelector('iframe').src = data_url;
    // console.log(res)
    xhr.open('GET', url);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === xhr.DONE) {
        if (xhr.status === 200) {
          var data_url = URL.createObjectURL(xhr.response);
          const iframe = document.querySelector('iframe')
          iframe!.src = data_url;
          iframe!.onload = () => {
            this.$store.commit('stopLoading')
          }
        } else {
          console.error('Erreur chargement printable:', xhr.status);
          this.$store.commit('stopLoading')
        }
      }
    };
    xhr.responseType = 'blob';
    xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.state.mainStore.userToken);
    xhr.send();


  }

  printAttestation(event: any) {
    // let link = event.data.data
    // console.log(link)
    // const div = document.createElement('div')
    // div.classList.add('hidden')
    // div.innerHTML = link
    // document.body.appendChild(div)
    // link = div.innerText;
    //
    // (async () => {
    //   const browser = await puppeteer.launch({ headless: true })
    //   const page = await browser.newPage()
    //   await page.setViewport({ width: 1280, height: 720 });
    //   await page.goto(link,{ waitUntil: 'networkidle0' })
    //   // await page.type('#login_field', process.env.GITHUB_USER)
    //   // await page.type('#password', process.env.GITHUB_PWD)
    //   // await page.click('[name="commit"]')
    //   await page.waitForNavigation()
    //   await page.screenshot({
    //     path: 'screenshot.jpg'
    //   })
    //   browser.close()
    //   // console.log('See screenshot: ' + screenshot)
    // })()
  }

  create() {

  }

  edit() {

  }

  save() {

  }

  print() {
    (document as any).getElementById("iframe")!.contentWindow.print();
  }

  json: any = null

  event: any = null

  async xhrListener(event: any) {
    // Action speciale POST : saisie manuelle d'un numero ATD
    if (event.data && event.data.action === 'set-manual-atd') {
      const {coverageUuid, atd} = event.data.data || {};
      if (!coverageUuid || !atd) {
        await Swal.fire({icon: 'error', title: 'Donnees invalides'});
        return;
      }
      this.$store.commit('loading');
      try {
        const res = await api.post(api.core, 'demande/attestation/manual/' + coverageUuid, {atd});
        if (res?.data?.status === 'success') {
          await Swal.fire({icon: 'success', title: 'Numero ATD enregistre', text: res.data.atd, timer: 1800, showConfirmButton: false});
          window.location.reload();
        } else {
          await Swal.fire({icon: 'error', title: 'Erreur', text: res?.data?.message || 'Echec de l\'enregistrement'});
        }
      } catch (e: any) {
        await Swal.fire({icon: 'error', title: 'Erreur', text: e?.response?.data?.message || e.message});
      } finally {
        this.$store.commit('stopLoading');
      }
      return;
    }

    if (event.data.method === 'GET') {

      // console.log('process')
      if (JSON.stringify(event) !== this.event) {
        // console.log('go')
        this.event = JSON.stringify(event.data)
      } else {
        // console.log('stop')
        return
      }

      this.$store.commit('loading')
      if (event.data === 'reload') {
        window.location.reload()
        return
      }
      if (event.data.action === 'retry-atd-download') {
        // Recharge l'iframe en forcant la re-tentative de telechargement de l'attestation
        await this.getData(true)
      } else if (event.data.action === 'router-push' && event.data.data.name) {
        this.$router.push(event.data.data)
      } else if (event.data.action === 'download') {
        const res = await api.get('', event.data.url, {responseType: 'blob'})
        const blob = new Blob([res.data], {type: res.headers['content-type']});
        let url = window.URL || window.webkitURL;
        let link = url.createObjectURL(blob);
        let a = document.createElement('a');
        a.setAttribute("download", res.headers['name']);
        a.setAttribute("href", link);
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      } else if (event.data.action === 'show-json') {
        // console.log('SHOW JSON')
        // console.log(event.data.data)
        this.json = JSON.parse(event.data.data);
        (this.$refs as any).jsonViewer.show()
        this.$store.commit('stopLoading')
      } else if (event.data.action === 'preview-demande-attestation') {
        this.$store.commit('stopLoading')
        const uuid = event.data.data || this.$route.params.coverageUuid
        // Charger le preview
        this.$store.commit('loading')
        const previewRes = await api.get(api.core, 'demande/attestation/preview/' + uuid)
        this.$store.commit('stopLoading')
        if (previewRes && previewRes.data) {
          if (previewRes.data.status === 'error') {
            await Swal.fire({icon: 'error', title: 'Erreur', text: previewRes.data.message})
          } else {
            // Afficher le JSON dans la modale
            this.json = previewRes.data.preview;
            (this.$refs as any).jsonViewer.show()
            // Attendre que l'utilisateur ferme la modale, puis demander confirmation
            const self = this;
            (this.$refs as any).jsonViewer.$once('hidden', async () => {
              const response = await Swal.fire({
                title: "Confirmer l'envoi",
                html: "Envoyer cette demande d'attestation à l'ASACI ?",
                showCancelButton: true,
                confirmButtonText: "Envoyer",
                cancelButtonText: "Annuler",
              })
              if (response.isConfirmed) {
                self.$store.commit('loading')
                const res = await api.get(api.core, 'demande/attestation/new/' + uuid)
                if (res && res.data) {
                  if (res.data.status === 'error') {
                    await Swal.fire({icon: 'error', title: 'Erreur', text: res.data.message})
                  } else {
                    window.location.reload()
                  }
                }
                self.$store.commit('stopLoading')
              }
            })
          }
        }
      } else if (event.data.action === 'new-demande-attestation') {
        // Fallback direct sans preview
        this.$store.commit('stopLoading')
        const response = await Swal.fire({
          title: "Effectuer une nouvelle demande",
          html: "Envoyer une demande d'attestation à l'ASACI ?",
          showCancelButton: true,
          confirmButtonText: 'Envoyer',
        })
        if (response.isConfirmed) {
          this.$store.commit('loading')
          const uuid = event.data.data || this.$route.params.coverageUuid
          const res = await api.get(api.core, 'demande/attestation/new/' + uuid)
          if (res && res.data) {
            if (res.data.status === 'error') {
              await Swal.fire({icon: 'error', title: 'Erreur', text: res.data.message})
            } else {
              window.location.reload()
            }
          }
          this.$store.commit('stopLoading')
        }
      } else if (event.data.action === 'refresh-contract-date') {
        this.$store.commit('stopLoading')
        const response = await Swal.fire({
          title: "Actualiser les dates",
          html: "Attention cette action mettra à jour la date de debut du contrat à aujourd'hui, En cas d'echec de l'emission de l'attestation digitale vous pourrez faire une nouvelle demande si la date d'effet est dépassée",
          timer: 20000,
          timerProgressBar: true,
          showCancelButton: true,
          confirmButtonText: 'Actualiser',
          didOpen: () => {
          },
          willClose: () => {
          }
        })
        if (response.isConfirmed) {
          this.$store.commit('loading')
          const res = await api.get(api.core, 'contract/refresh/date/' + (event.data.data || this.$route.params.coverageUuid))
          window.location.reload()
          this.$store.commit('stopLoading')
        }
      } else if (event.data.action === 'print-e-attestation') {
        this.printAttestation(event)
      } else if (event.data.action === 'redirect') {
        if (window.hasOwnProperty('ReactNativeWebView')) {
          (window as any).ReactNativeWebView.postMessage('redirect to ' + event.data.url)
        }
      } else if (event.data.url) {
        const res = await api.get('', event.data.url)
        if (event.data.reload) {
          if (event.data.reload === true) {
            window.location.reload()
          }
        }
      }
      // console.log(res)
      this.$store.commit('stopLoading')
    }
  }


}
</script>
<style scoped></style>
